// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2d8rc","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3WVl2"};